var e="@hpstellar/pdp/gallery-next";export{e as galleryNextTestId};
